// @ts-check
// HUD de los tres editores (rediseño, Fase 4b; docs/rediseno-fase3-plan.md
// §4.3-4.5): la fila de paneles Ejercicios | Progreso | Autocorregir que va
// bajo la barra superior. Lo común a los tres vive aquí, una sola vez:
//
// - `crearCabeceraEditor`: la cabecera del panel Ejercicios, con la etiqueta
//   del editor («Flujo · …») y el enlace a su guía. Sustituye a las barras de
//   marca propias de cada editor («⚡ Flujo · …» + «📘 Guía de aprendizaje»).
// - `editor-hud.css`: la rejilla de la fila (`.editor-hud`) y el aspecto de la
//   cabecera. Las columnas son variables (`--editor-hud-columnas-*`) porque el
//   editor de diagramas monta su fila dentro de la zona protegida y la
//   compone con las mismas columnas sin llevar esta clase.
import { createSafeElement } from '../security/safe-dom.js';
import { crearIcono } from './base/iconos.js';
import './base/panel.css';
import './editor-hud.css';

/**
 * @param {{ marca: string, rutaGuia: string }} opciones
 *   `marca`: la etiqueta del editor («Flujo · Pseudocódigo»);
 *   `rutaGuia`: la guía de aprendizaje de ese editor.
 * @returns {HTMLElement}
 */
export function crearCabeceraEditor({ marca, rutaGuia }) {
  const cabecera = createSafeElement('div', { className: 'editor-hud-cabecera' });
  const etiqueta = createSafeElement('p', { className: 'ui-etiqueta', text: marca });
  const guia = /** @type {HTMLAnchorElement} */ (
    createSafeElement('a', { className: 'editor-hud-guia' })
  );
  // Constante del código, no dato de usuario: se deja relativa tal cual (las
  // pruebas y el alumno ven `/guia-….html`).
  guia.href = rutaGuia;
  guia.append(crearIcono('libro'), document.createTextNode('Guía de aprendizaje'));
  cabecera.append(etiqueta, guia);
  return cabecera;
}
